// extracted by mini-css-extract-plugin
export default {"card":"style_card__KyHkO","title":"style_title__54bnd"};